var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.5,
    height: 233.059,
    viewBox: "0 0 324.5 233.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_test-bro",
    "data-name": "Online test-bro",
    transform: "translate(-50.33 -173.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-141",
    transform: "translate(50.33 386.133)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    x1: 23.099,
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    x1: 293.876,
    transform: "translate(30.624)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-141",
    transform: "translate(155.781 173.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9842",
    "data-name": "Path 9842",
    d: "M342.378,412.136l4.94-75.026,3.636-35.672-9.973-11.131-5-3.636s-7.042,6.137-12.036,7.495-9.8,2.731-9.8,2.731-17.038,32.036-18.411,46.573-3.636,68.391-3.636,68.391l1.895.276Z",
    transform: "translate(-212.079 -200.146)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9843",
    "data-name": "Path 9843",
    d: "M327.045,368.125s-.852-.437.852-4.825",
    transform: "translate(-220.167 -217.99)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9844",
    "data-name": "Path 9844",
    d: "M324.5,298.11a147.413,147.413,0,0,1,1.4,18.289s5.117-2.048,9.206-9.206a82.676,82.676,0,0,0,5.815-12.013Z",
    transform: "translate(-219.624 -202.127)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9845",
    "data-name": "Path 9845",
    d: "M342.385,428.962l4.442-67.455c-4.357,2.225-12.957,5.9-22.447,6.06-11.369.192-25.446-8.638-25.446-8.638l-3.168,1.243v.123c-1.366,14.576-3.636,68.391-3.636,68.391l1.895.276Z",
    transform: "translate(-212.086 -216.972)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9846",
    "data-name": "Path 9846",
    d: "M348,374.74c0,17.376.6,34.092.767,37.743h33.486c.46-5.416,3.345-39.124,4.825-51.207,1.619-13.2,12.236-32.857,12.236-39.891s2.156-5.922-7.541-11.039-31.085-16.164-34.046-17.514a26.526,26.526,0,0,1-6.2-4.6s1.074,6.735.767,25.047S348,355.094,348,374.74Z",
    transform: "translate(-225.096 -200.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4123",
    "data-name": "Group 4123",
    transform: "translate(123.026 87.79)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9847",
    "data-name": "Path 9847",
    d: "M352.6,288.32a90.983,90.983,0,0,1,.69,9.6v-8.953C352.861,288.581,352.6,288.32,352.6,288.32Z",
    transform: "translate(-349.194 -288.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9848",
    "data-name": "Path 9848",
    d: "M395.6,333.939v2.3c.261-.7.522-1.373.767-2.041v-.276h.1c.1-.253.192-.514.284-.767h-.384v-9.551h2.969v-.767h-2.969v-8.178c-.238-.146-.491-.284-.767-.437v8.615h-8.055v-9.589h6.229l-1.442-.767h-4.787V309.95l-.767-.407v2.915h-8.055v-7.1l-.767-.4v7.5H369.9v-9.566h4.012l-1.488-.767H369.9v-1.3l-.767-.4v1.7h-8.055v-5.792c-.268-.138-.522-.268-.767-.384v6.175h-7.978v.767h7.978v9.589H352.4v.767h7.909v9.589h-8.055v-3.644c-.153,3.744-.43,7.671-.767,11.668v2.3h-.2l-.069.767h.268v9.62h-1.151l-.077.767h1.266v9.589h-2.179l-.069.767h2.248v9.589h-2.992l-.046.767h3.069v9.589h-3.4v.767h3.406v9.589h-3.383v.767h3.375v9.589h-3.222v.767h3.207v18.22h.767V396.077h8V414.3h.767v-18.22h8.055V414.3h.767v-18.22h8.055V414.3h.767v-18.22h5.163a2.917,2.917,0,0,1,.069-.767h-5.232v-9.566h6.137c0-.253.054-.506.077-.767h-6.214v-9.589h7.088a6.492,6.492,0,0,1,.077-.767h-7.165v-9.589h8.055v1.02l.338-2.938c.107-.859.253-1.749.43-2.662v-5.777h1.435l.23-.767h-1.665v-9.589h4.986c.1-.253.192-.514.292-.767h-5.278v-9.589Zm-8.055-10.333H395.6v9.589h-8.055Zm-27.233,71.7h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm8.822,62.138h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm8.822,82.851H369.9v-9.566h8.055Zm0-10.356H369.9v-9.589h8.055Zm0-10.356H369.9v-9.566h8.055Zm0-10.356H369.9v-9.589h8.055Zm0-10.356H369.9v-9.566h8.055Zm0-10.356H369.9v-9.589h8.055Zm0-10.356H369.9v-9.566h8.055Zm0-10.356H369.9v-9.589h8.055Zm8.822,41.426h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.566h8.055Zm0-10.356h-8.055v-9.589h8.055Z",
    transform: "translate(-348.16 -290.097)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9849",
    "data-name": "Path 9849",
    d: "M348,374.74c0,17.376.6,34.092.767,37.743h33.486c.46-5.416,3.345-39.124,4.825-51.207,1.619-13.2,12.236-32.857,12.236-39.891s2.156-5.922-7.541-11.039-31.085-16.164-34.046-17.514a26.526,26.526,0,0,1-6.2-4.6s1.074,6.735.767,25.047S348,355.094,348,374.74Z",
    transform: "translate(-225.096 -200.509)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9850",
    "data-name": "Path 9850",
    d: "M352.6,288.32s1.074,6.736.767,25.047c-.061,4.6-.376,9.574-.767,14.7.921-1.266,3.889-5.309,4.6-5.539.806-.268,5.117,3.774,8.615,4.311s4.848.537,1.082-3.506-5.37-15.887-6.735-24.779a34.526,34.526,0,0,0-1.25-5.615h-.092A26.932,26.932,0,0,1,352.6,288.32Z",
    transform: "translate(-226.168 -200.53)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9851",
    "data-name": "Path 9851",
    d: "M374.2,396.282c2.478-1.128,4.426-2.1,4.426-2.1l.913,7.042s-13.41,5.907-20.9,6.36-8.178.683-8.178.683l.222-6.812",
    transform: "translate(-225.669 -225.181)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9852",
    "data-name": "Path 9852",
    d: "M372.66,399.965c1.373-.46,2.984-1.112,4.557-1.8",
    transform: "translate(-230.839 -226.11)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9853",
    "data-name": "Path 9853",
    d: "M354,402.446a89.875,89.875,0,0,0,11.707-1.066",
    transform: "translate(-226.493 -226.857)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_193",
    "data-name": "Line 193",
    x2: 0.453,
    y2: 5.454,
    transform: "translate(153.873 176.042)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9854",
    "data-name": "Path 9854",
    d: "M249.875,414.677h37.682c.084-2.954,1.174-40.49,1.91-59.645.767-19.946,14.3-50.2,14.3-50.2s1.81-4.265-.107-6.183-6.521-1.151-9.973,1.534S258.4,316.674,256.48,318.592s-1.534,8.439-2.3,16.11-13.425,60.6-13.425,60.6a20.721,20.721,0,0,0-4.6,1.534c-1.151.767-1.151,3.069-1.151,3.069a38.059,38.059,0,0,1,6.137,2.685C245.372,404.711,249.276,413.3,249.875,414.677Z",
    transform: "translate(-198.783 -202.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9855",
    "data-name": "Path 9855",
    d: "M299.257,313.638v3.92c.261-.706.514-1.389.767-2.048v-1.872h.721l.3-.767h-1.02V303.3h4.833c.054-.238.115-.5.153-.767h-4.986V297.72c-.253.038-.506.077-.767.138v4.68H291.2v-.522l-.767.391v.13h-.261l-1.534.767h1.8v9.589H282.38v-6.6l-.767.361v6.214h-8.055v-2.447l-.767.361v2.087h-4.457l-1.626.767h6.083v9.612h-8.055v-8.669l-.767.368v8.3h-8.055v-1.933a67.808,67.808,0,0,0-.767,8.439v3.836h-.276l-.069.767h.345v9.6h-2.064l-.161.767h2.225v9.589h-4.3c-.054.253-.115.514-.169.767h4.472v9.589h-6.636c-.061.261-.115.514-.176.767h6.812v9.589h-8.055v-4.219l-.767,3.314v.867h-.2l-.176.767h.376v9.628H243.7l-.184.767h2.808v9.589h-6.513a20.112,20.112,0,0,0-2.3.767h0v4.173c.23.092.483.2.767.33v-4.5h8.047v10.74c.269.384.522.767.767,1.158V396.52h8.055v18.22h.767v-18.25h8.055v18.22h.767v-18.22h8.055v18.22h.767v-18.22h8.055v18.22h.767v-18.22h6.3v-.767h-6.3v-9.566H289v-.767h-6.62V375.8h6.95v-.767h-6.95v-9.589h7.3v-.767h-7.3v-9.589h7.671a5.192,5.192,0,0,1,.038-.767h-7.71V344.73h8.055V350.4c.2-1.634.453-3.314.767-5.017v-.652h.123c.046-.253.1-.506.146-.767H291.2v-9.589h2.57c.069-.253.146-.506.215-.767H291.2v-9.589h5.754c.092-.253.176-.514.261-.767H291.2v-9.589ZM291.2,303.3h8.055v9.589H291.2Zm-36.056,92.44h-8.055v-9.589h8.055Zm0-10.356h-8.055V375.8h8.055Zm8.822,10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055V375.8h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055V344.73h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm8.822,62.138h-8.055v-9.589h8.055Zm0-10.356h-8.055V375.8h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055V344.73h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm8.822,62.138h-8.055v-9.589h8.055Zm0-10.356h-8.055V375.8h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055V344.73h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.589h8.055Zm8.822,20.713H282.38v-9.589h8.055Zm0-10.356H282.38v-9.589h8.055Zm0-10.356H282.38v-9.589h8.055Z",
    transform: "translate(-199.368 -202.719)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9856",
    "data-name": "Path 9856",
    d: "M249.875,414.677h37.682c.084-2.954,1.174-40.49,1.91-59.645.767-19.946,14.3-50.2,14.3-50.2s1.81-4.265-.107-6.183-6.521-1.151-9.973,1.534S258.4,316.674,256.48,318.592s-1.534,8.439-2.3,16.11-13.425,60.6-13.425,60.6a20.721,20.721,0,0,0-4.6,1.534c-1.151.767-1.151,3.069-1.151,3.069a38.059,38.059,0,0,1,6.137,2.685C245.372,404.711,249.276,413.3,249.875,414.677Z",
    transform: "translate(-198.783 -202.687)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9857",
    "data-name": "Path 9857",
    d: "M235,429.6a38.062,38.062,0,0,1,6.137,2.685c4.6,2.3,8.822,12.274,8.822,12.274h7.434c.468-1.4,1.611-6.475-3.6-12.658-6.137-7.288-13.041-6.9-13.041-6.9a20.72,20.72,0,0,0-4.6,1.534C235,427.3,235,429.6,235,429.6Z",
    transform: "translate(-198.783 -232.356)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9858",
    "data-name": "Path 9858",
    d: "M312.828,297.736c-1.649,4.365-5.554,14.238-8.791,18.941-4.219,6.137-11.891,11.123-9.206,13.425s10.356-4.986,10.356-4.986,1.918,5.37,2.3,6.9a.576.576,0,0,0,.1.192,241.061,241.061,0,0,1,9.973-27.379s1.81-4.265-.107-6.183C316.464,297.652,314.777,297.391,312.828,297.736Z",
    transform: "translate(-212.586 -202.689)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9859",
    "data-name": "Path 9859",
    d: "M281.94,344.751a39.923,39.923,0,0,0,.43-4.281",
    transform: "translate(-209.714 -212.674)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9860",
    "data-name": "Path 9860",
    d: "M274,428.189s1.151-24.548,1.151-38.741c0-10.226,2.785-27.425,4.35-37.958",
    transform: "translate(-207.865 -215.24)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9861",
    "data-name": "Path 9861",
    d: "M276.267,394a75.987,75.987,0,0,0,9.206,2.3l9.206,1.151-.7,8.692s-.453-.253-7.357-2.555S275.5,399.37,275.5,399.37",
    transform: "translate(-208.214 -225.139)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9862",
    "data-name": "Path 9862",
    d: "M297.357,409.8s-.453,17.031-.453,19.332-6.9.767-6.9.767",
    transform: "translate(-211.59 -228.818)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9863",
    "data-name": "Path 9863",
    d: "M303.53,271.139s7.234,10.4,13.709,15.2,12-1.918,16.317-9.114,7.2-12.474,9.351-18.711,0-16.547-8.63-24.7-28.791-20.153-33.823-13.916-9.835,19.946-6.482,31.66a61.886,61.886,0,0,0,9.559,19.585Z",
    transform: "translate(-212.255 -184.193)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9864",
    "data-name": "Path 9864",
    d: "M302.8,257.864a14.576,14.576,0,0,1,8.37,0",
    transform: "translate(-214.571 -193.295)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9865",
    "data-name": "Path 9865",
    d: "M310.2,265.791c.23,1.243-.061,2.34-.652,2.447s-1.243-.813-1.473-2.064.061-2.34.652-2.447S309.971,264.541,310.2,265.791Z",
    transform: "translate(-215.781 -194.801)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9866",
    "data-name": "Path 9866",
    d: "M338.021,266.221c.222,1.243-.069,2.3-.652,2.447s-1.243-.813-1.473-2.064.061-2.34.652-2.447S337.791,264.971,338.021,266.221Z",
    transform: "translate(-222.259 -194.902)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9867",
    "data-name": "Path 9867",
    d: "M318.08,288.1a22.592,22.592,0,0,0,8.63,1.2c5.04-.238,9.359-3.836,9.359-3.836",
    transform: "translate(-218.129 -199.864)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9868",
    "data-name": "Path 9868",
    d: "M293,214.884s10.656,24.3,11.99,24.97,4-7.326,4-7.326,3.659,6.651,8,8.653,5.661-1.327,5.661-1.327a74.405,74.405,0,0,1,6.329,4l1.665,1.327,1.665,5.991s-4.994,16.317-3.329,18.319,10.985-.667,10.985-.667-2.3,3.329.667,3.329,8.323.667,15.979-9.658,8.323-26.965,8.323-26.965,3.659,3.989,4-1-4.327-13.318-4.327-13.318,7.319,7.326,6.659-.33-4.994-16.317-6.659-18.312-11.661-7.671-11.661-7.671,4-.667,1-5.332-13.985-5.991-17.982-5.991a112.12,112.12,0,0,0-12.32,1.335s5.332-10.326-.33-10.993-15.65,10.326-15.65,10.326-9.973-7.994-12.988-6.329-1,4-1,4-12.98,1-16.647,6.659.667,8.991.667,8.991-23.306,15.98-19.646,21.971,10.326.338,10.326.338-9.328,23.973-7.994,25.638,7.671-.667,7.671-.667-.33,19.309,4.664,21.311,5.991-1.665,5.991-1.665,2.662,2.662,8.661,2.992,7.986-6.659,7.986-6.659-6.659-15.65-6.321-28.63S293,214.884,293,214.884Z",
    transform: "translate(-204.062 -173.882)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9869",
    "data-name": "Path 9869",
    d: "M320.838,263.88s-2.4,12.474-.483,15.113,8.638,0,9.114-1.435",
    transform: "translate(-218.486 -194.839)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 9.474,
    cy: 6.958,
    rx: 9.474,
    ry: 6.958,
    transform: "translate(82.92 62.804)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 9.474,
    cy: 6.958,
    rx: 9.474,
    ry: 6.958,
    transform: "translate(105.704 62.329)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9870",
    "data-name": "Path 9870",
    d: "M321.21,263.707s1.918-1.435,3.352.245",
    transform: "translate(-218.858 -194.666)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9871",
    "data-name": "Path 9871",
    d: "M218.31,435.68s12.044-3.4,15.749-4.012,11.124,6.175,12.359,9.881-.345,4.534-.345,4.534l-24.679-.821Z",
    transform: "translate(-194.897 -233.901)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9872",
    "data-name": "Path 9872",
    d: "M215.568,435.229s9.091,3.406,11.361,4.772,1.588,4.089.23,5.447a12.826,12.826,0,0,1-5.684,2.731,55.922,55.922,0,0,1-6.36,0c-2.723-.23-5.224.23-7.495.23s-9.091-.683-9.091-.683l-2.048-1.366s-3.836,1.135-6.812,2.3-2.048-1.366.222-3.184,7.955-6.36,8.868-6.812,12.5-3.836,12.5-3.836Z",
    transform: "translate(-187.79 -234.646)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9873",
    "data-name": "Path 9873",
    d: "M221.012,435.7s-5.915-2.723-7.5-2.723-12.949,3.836-14.537,4.994-3.184,12.044-2.048,12.727,2.048-1.366,2.3-2.723,3.414-8.638,3.414-8.638l-2.3,11.591s.913,1.81,1.818.222,6.59-12.5,7.042-13.179a8.3,8.3,0,0,1,2.048-1.588s-1.135,5-2.048,9.773-.222,6.137,1.143,6.36,2.041-2.953,2.723-4.541,3.636-10.686,3.636-10.686",
    transform: "translate(-189.827 -234.216)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9874",
    "data-name": "Path 9874",
    d: "M234.486,442.408s-6.812,7.042-7.725,8.63-.905,1.818,1.6,1.818,10.226-5,10.9-5.685.46-2.723-1.135-4.089A4.028,4.028,0,0,0,234.486,442.408Z",
    transform: "translate(-196.735 -236.371)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9875",
    "data-name": "Path 9875",
    d: "M287.55,441.379s-9.091,2.938-11.323,4.6-5.454,3.5-4.756,4.058,2.938,0,3.636-.56,3.912-1.12,3.912-1.12,3.774-2.24,6.712-4.051S290.9,440.535,287.55,441.379Z",
    transform: "translate(-207.253 -236.124)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9876",
    "data-name": "Path 9876",
    d: "M338.3,421.38s-25.316,4.6-34.475,7.817-12.8,5.454-17.383,8.692-13.862,9.351-12.481,10.425,6.191-2.693,7-3.5,6.728-3.23,6.728-3.23l3.958-2.025s-5.961,7.341-8.109,9.206-.7,3.03.921,2.493,4.672-3.751,4.672-3.751l9.842-6.475s-4.043,5.661-5.93,7.272,2.156,2.969,2.969,1.619,4.848-4.848,4.848-4.848,6.728-3.5,8.346-4.848,5.654-5.117,5.654-5.117l30.164,2.424s1.887-1.074.813-7.273S338.3,421.38,338.3,421.38Z",
    transform: "translate(-207.823 -231.514)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9877",
    "data-name": "Path 9877",
    d: "M381.77,348.871l14.813,36.639-23.973,8.346,6.736,19.662s17.215.046,30.686-.767,22.922-8.937,20.766-18.626-10.234-23.7-16.7-40.405-4.465-26.658-7.426-31.775-11.315-6.467-11.315-6.467l-4.6-.767",
    transform: "translate(-230.827 -206.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9878",
    "data-name": "Path 9878",
    d: "M429.132,404.391v-3.836h2c.084-.253.153-.506.215-.767h-2.217v-9.6h1.151c-.084-.245-.176-.506-.261-.767h-.89v-2.34c-.245-.637-.5-1.289-.767-1.941v4.281H420.31v-9.589h5.784c-.115-.253-.222-.506-.338-.767H420.31v-9.589h1.074c-.123-.253-.238-.506-.353-.767h-.721v-1.6c-.253-.568-.514-1.135-.767-1.711v3.314h-8.055v-9.589h5.37c-.107-.253-.215-.506-.315-.767h-5.055v-9.589h1.435c-.084-.253-.161-.514-.238-.767h-1.2v-4.373c-.292-1.212-.545-2.37-.767-3.483V348h-8.055v-9.589H410.4l-.138-.767h-7.595v-9.589h6.3l-.115-.767h-6.183v-9.405a21.731,21.731,0,0,0-2.071-.974h-6.751v-1.718l-.767-.138v1.857h-2.263l-.207.767h2.47v9.612H388.09l-.2.767h5.194v9.589h-7.725l-.207.767h7.925V348h-8.055v-9.1l-.767,2.907v6.137h-1.626l-.2.767h1.826v4.856l.767,1.895v-6.7h8.055v9.589h-6.9l.307.767h6.6v9.589h-2.685l.315.767h2.409v5.961l.767,1.895v-7.855H401.9v9.589h-7.357l.315.767H401.9v9.589h-8.055V386.77l-.767.269v2.386h-6.858l-2.209.767h.245v9.589H376.2v-6.9l-.767.268v6.6h-.222l.99,2.884v-2.117h8.055v13.041h.767V400.509h8.055v12.942h.767V400.525H401.9v12.681h.767V400.525h8.055V412.8l.767-.061V400.525h8.055V411.05l.767-.292V400.525h8.055v4.818C428.634,405.028,428.894,404.713,429.132,404.391Zm-36.056-4.6h-8.055v-9.6h8.055Zm8.822,0h-8.055v-9.6H401.9Zm0-31.069h-8.055V359.13H401.9Zm0-10.356h-8.055v-9.6H401.9Zm0-10.356h-8.055v-9.589H401.9Zm0-10.356h-8.055v-9.6H401.9Zm0-10.356h-8.055V317.7H401.9Zm8.822,72.495h-8.055v-9.6h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.6h8.055Zm0-10.356h-8.055V359.13h8.055Zm0-10.356h-8.055v-9.6h8.055Zm8.822,41.426h-8.055v-9.6h8.055Zm0-10.356h-8.055v-9.589h8.055Zm0-10.356h-8.055v-9.6h8.055Zm.767,20.713v-9.6h8.055v9.589Z",
    transform: "translate(-231.432 -206.754)",
    fill: "#263238",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9879",
    "data-name": "Path 9879",
    d: "M381.77,348.871l14.813,36.639-23.973,8.346,6.736,19.662s17.215.046,30.686-.767,22.922-8.937,20.766-18.626-10.234-23.7-16.7-40.405-4.465-26.658-7.426-31.775-11.315-6.467-11.315-6.467l-4.6-.767",
    transform: "translate(-230.827 -206.675)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9880",
    "data-name": "Path 9880",
    d: "M418.282,401.062a107.406,107.406,0,0,0-14.422,3.721s10.234-6.735,15.887-7.272",
    transform: "translate(-238.104 -225.956)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9881",
    "data-name": "Path 9881",
    d: "M430.627,401.675a14.743,14.743,0,0,0-3.207-.107",
    transform: "translate(-243.59 -226.891)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9882",
    "data-name": "Path 9882",
    d: "M375.577,413.513s5.447,5.209,7.058,9.244,1.02,15-.054,16.072-21.119.944-24.418-3.176c-.859-1.074,5.025-3.552,2.064-9.482s-4.311-6.459-4.311-6.459-2.424-1.35,2.156-4.311S373.153,410.291,375.577,413.513Z",
    transform: "translate(-226.79 -229.309)",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drink--inject-141",
    transform: "translate(328.855 357.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9883",
    "data-name": "Path 9883",
    d: "M437.2,456.208H417.316L414.83,416.9h24.855Z",
    transform: "translate(-413.733 -413.785)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1506",
    "data-name": "Rectangle 1506",
    width: 27.057,
    height: 5.723,
    transform: "translate(0 3.176)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9884",
    "data-name": "Path 9884",
    d: "M440.457,416.231H413.4l2.7-3.391h21.649Z",
    transform: "translate(-413.4 -412.84)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9885",
    "data-name": "Path 9885",
    d: "M438.161,448.357l.99-15.657H415.83l.99,15.657Z",
    transform: "translate(-413.966 -417.465)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-141",
    transform: "translate(109.369 328.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9886",
    "data-name": "Path 9886",
    d: "M294.62,469.585l24.5-6.475v3.314l-24.5,6.866Z",
    transform: "translate(-166.255 -395.556)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9887",
    "data-name": "Path 9887",
    d: "M280.158,463.11h-128.1l-24.763,6.475H255.655Z",
    transform: "translate(-127.29 -395.556)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1507",
    "data-name": "Rectangle 1507",
    width: 128.365,
    height: 77.734,
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9888",
    "data-name": "Path 9888",
    d: "M255.665,389.71c-27.924,1.327-44.555,27.065-69.265,44.31-22.523,15.726-50.34,18.411-59.07,18.833V456.2H255.665Z",
    transform: "translate(-127.299 -378.464)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1508",
    "data-name": "Rectangle 1508",
    width: 128.365,
    height: 3.705,
    transform: "translate(0 74.029)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-141",
    transform: "translate(59.605 332.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9889",
    "data-name": "Path 9889",
    d: "M76.1,428.381s-10.694-17.107-2.11-26.735,22.454-4.994,25.316,3.92S96.1,429.455,96.1,429.455Z",
    transform: "translate(-64.337 -383.937)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9890",
    "data-name": "Path 9890",
    d: "M74.533,407.691c-1.78,0-8.554-2.493-10.694-5.7s-2.509-10.341,3.567-10.341,8.2,10.694,8.2,10.694l.353,3.92",
    transform: "translate(-62.42 -382.855)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9891",
    "data-name": "Path 9891",
    d: "M83.211,398.362c-1.6-.767-6.544-6.045-7.027-9.873s2.386-10.364,7.809-7.671,2.562,13.233,2.562,13.233l-1.435,3.667",
    transform: "translate(-65.613 -380.185)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9892",
    "data-name": "Path 9892",
    d: "M93.423,401.139c-.89-1.534-2.087-8.661-.368-12.113s7.733-7.3,10.74-2.041-5.209,12.428-5.209,12.428l-3.23,2.255",
    transform: "translate(-69.351 -381.167)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9893",
    "data-name": "Path 9893",
    d: "M96.558,418.677c-.292-1.764,1.043-8.853,3.836-11.507s9.781-4.181,10.786,1.8-9.206,9.865-9.206,9.865l-3.836,1",
    transform: "translate(-70.361 -385.924)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    x2: 1.204,
    y2: 1.895,
    transform: "translate(2.201 14.833)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    x2: 1.887,
    y2: 1.542,
    transform: "translate(5.646 19.481)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    x2: 1.887,
    y2: 2.754,
    transform: "translate(3.582 11.219)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    x2: 2.064,
    y2: 3.782,
    transform: "translate(8.055 16.213)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    x2: 0.69,
    y2: 2.064,
    transform: "translate(12.865 7.092)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    x2: 1.204,
    y2: 1.726,
    transform: "translate(15.273 12.938)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    x2: 1.55,
    y2: 3.437,
    transform: "translate(14.759 2.965)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    x2: 0.522,
    y2: 3.092,
    transform: "translate(8.737 27.222)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x2: 0.69,
    y2: 2.585,
    transform: "translate(10.287 33.236)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    x2: 0.69,
    y2: 3.437,
    transform: "translate(12.005 27.391)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    x2: 0.514,
    y2: 2.585,
    transform: "translate(14.245 33.236)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    x2: 1.028,
    y2: 4.818,
    transform: "translate(15.45 22.918)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    x2: 0.169,
    y2: 2.24,
    transform: "translate(17.859 32.377)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    x2: 0.859,
    y2: 4.472,
    transform: "translate(19.746 21.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    x2: 0.345,
    y2: 4.641,
    transform: "translate(20.605 30.49)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    y2: 3.79,
    transform: "translate(24.74 23.087)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    x2: 0.176,
    y2: 2.923,
    transform: "translate(24.218 31.694)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    x1: 0.859,
    y2: 2.071,
    transform: "translate(28.177 5.197)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    x1: 0.859,
    y2: 2.93,
    transform: "translate(26.972 9.67)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    x1: 1.373,
    y2: 2.754,
    transform: "translate(31.445 9.156)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    x1: 1.55,
    y2: 1.718,
    transform: "translate(26.972 15.009)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x1: 0.514,
    y2: 2.232,
    transform: "translate(24.74 8.987)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x1: 1.887,
    y2: 3.099,
    transform: "translate(30.931 21.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    x1: 1.036,
    y2: 2.754,
    transform: "translate(28.691 26.355)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    y1: 1.726,
    x2: 3.092,
    transform: "translate(31.276 28.764)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    x1: 1.55,
    y2: 2.585,
    transform: "translate(34.713 21.369)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    x1: 2.064,
    y2: 1.55,
    transform: "translate(35.748 24.291)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1509",
    "data-name": "Rectangle 1509",
    width: 29.243,
    height: 29.243,
    transform: "translate(6.344 38.476)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar3);
export default __webpack_public_path__ + "static/media/char3.5c922987ece6aff2af98b390073d198b.svg";
export { ForwardRef as ReactComponent };